import React, { Fragment } from "react";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getRequestsList } from "../../store/requests/actions";
import Skeleton from "../../components/vwSkeleton/vwSkeleton";
import NoRecord from "../../components/NoRecords/noRecords";
import {
  Badge,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Table
} from "reactstrap";
import { getPager } from "../../helper/common";
import VWPagination from "../../components/vwPagination/vwPagination";
import Message from "../../CommonData/Data/Message";
import VWLoading from "../../components/vwLoading/vwLoading";
import { SUPER_ADMIN } from "../../store/users/role.constants";

const style = {
  table: {
    width: '100%',
    display: 'table',
    borderSpacing: 0,
    borderCollapse: 'separate',
  },
  th: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#fff',
  },
};

const Requests = (props) => {
  const { requestList, isGetRequestsPending, errorMessage, currentProfile } = props;
  const [pageSize, setPageSize] = useState(10);
  const [pager, setPager] = useState({ currentPage: 1 });

  const isSuperAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
    (currentProfile.roles[0].roleKey === SUPER_ADMIN);
  const setPage = (page = 1) => {
    props.getRequestsList(page, pageSize, sortDirection, sortOrder);
    setPager(prevPager => {
      const totalPages = Math.ceil(props.totalRecords / pageSize);
      const visiblePages = 10;
      const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
      const newPages = [];
      for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
        newPages.push(i);
      }
      return {
        ...prevPager,
        currentPage: page,
        totalPages,
        pages: newPages,
      };
    });
  };
  useEffect(() => {
    const currentUpdatePager = getPager(props.totalRecords, 1, pageSize);
    setPager(currentUpdatePager);
  }, [props.totalRecords, pageSize]);

  // useEffect(() => {
  //   const currentPageNo = pager && pager.currentPage;
  //   setPage(currentPageNo);
  // }, []);

  useEffect(() => {
    setPage();
  }, [pageSize])

  const [sortDirection, setSortDirection] = useState('asc');
  const [sortOrder, setSortOrder] = useState(null);

  const handleSort = (column) => {
    if (sortOrder === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortOrder(column);
      setSortDirection('asc');
    }
  };
  useEffect(() => {
    if (sortOrder && sortDirection) {
      setPage();
    }
  }, [sortOrder, sortDirection])

  return (
    <Fragment>
      <div className="page-content">
        <Card>
          <CardTitle className="p-2 mb-0 fs-5 fw-bold text-dark">
            REQUESTS
          </CardTitle>
        </Card>
        <Card>
          <CardBody>
            {errorMessage && (
              <Message
                type="danger"
                defaultMessage={errorMessage}
                baseClassName="alert"
              />
            )}
            <div style={{ maxHeight: "500px", overflowX: "auto" }}>
              <Table className="table table-hover table-nowrap w-100" size='sm' style={style.table}>
                <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: "1" }}>
                  <tr>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('displayName')}>
                      NAME
                      {sortOrder === 'displayName' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('roleDisplayName')}>
                      ROLE
                      {sortOrder === 'roleDisplayName' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    {isSuperAdmin &&
                      <th style={{ cursor: "pointer" }} onClick={() => handleSort('orgName')}>
                        ORGANIZATION
                        {sortOrder === 'orgName' && (
                          <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                        )}
                      </th>
                    }
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('status')}>
                      STATUS
                      {sortOrder === 'status' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('requestor')}>
                      REQUESTOR
                      {sortOrder === 'requestor' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {(requestList && requestList.length > 0) && !isGetRequestsPending ?
                    (requestList.map((data, index) => (
                      <tr key={index}>
                        <td>
                          {data.displayName || "NA"}<br />
                          <small>{data.email || "NA"}</small>
                        </td>
                        <td>{data.roleDisplayName || "NA"}</td>
                        {isSuperAdmin &&
                          <td>{data.orgName || "NA"}</td>
                        }
                        <td>
                          {data.status === "pending" ? (
                            <Badge color="warning">Pending</Badge>
                          ) : (
                            <Badge color="success">
                              Approved
                            </Badge>
                          )}
                        </td>
                        <td>
                          {data.requestor || "NA"}<br />
                          <small>{data.requestorEmail || "NA"}</small>
                        </td>
                      </tr>
                    )))
                    : isGetRequestsPending ? (
                      <tr>
                        <td colSpan={9} align="center" className="p-4">
                          <Skeleton type="body" />
                          <VWLoading />
                        </td>
                      </tr>
                    ) :
                      <tr>
                        <td colSpan={9}>
                          <NoRecord />
                        </td>
                      </tr>
                  }
                </tbody>
              </Table>
            </div >
          </CardBody>
          <CardFooter>
            {props.requestList.length > 0 ?
              <VWPagination
                pager={pager}
                setPage={setPage}
                totalRecords={props.totalRecords}
                pageSize={pageSize}
                setPageSize={setPageSize}
              /> : null
            }
          </CardFooter>
        </Card>
      </div>
    </Fragment >
  );
}

const mapStateToProps = (state) => ({
  requestList: state.requests.requests,
  errorMessage: state.requests.errorMessage,
  totalRecords: state.requests.totalRecords,
  isGetRequestsPending: state.requests.isGetRequestsPending,
  currentProfile: state.login.currentProfile,
});

const mapDispatchToProps = (dispatch) => ({
  getRequestsList: (page, pageSize, sortDirection, sortOrder) =>
    dispatch(getRequestsList(page, pageSize, sortDirection, sortOrder)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Requests);
